import { Invoice } from '../../../models';

/* istanbul ignore file */
export class InvoiceLogicServiceModel {
    invoices: Invoice[] = [];
}
